module.exports = __webpack_public_path__ + "static/img/card-title1.a5b92d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/weTech/card-title1.png
// module id = Iyy3
// module chunks = 2